export default __webpack_public_path__ + "39a4cd6c3948bfc9201653013a5bbbc0.svg";